import { DisabledPrompt } from "@bcm-dev/bcms-vite";
import CustomTableAccordion, { CustomTableContent, CustomTableToggle } from "components/custom-ui/CustomTableAccordion";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function EntitlementsTableAccordion
 * @returns {React.Component}
 * @description The is the Entitlements table accordion used in the main EntitlementsTable component.
 */
export default function EntitlementsTableAccordion(props) {
    return (
        <CustomTableAccordion className="entitlements-table-accordion" activeClass="open-custom-entitlements-table-accordion" state={{ isActive: true }}>
            <EntitlementsTableToggle {...props} />
            {props.children}
        </CustomTableAccordion>
    )
}

/**
 * @function EntitlementsTableToggle
* @param {STRING} header - Sets the transfer template type text.
 * @return {React.Component}
 * @exported false
 * @description This is the entitlements table toggle.
 */
function EntitlementsTableToggle(props) {
    const header = props.header ?? "[header]";
    const icon = props.icon ?? "";
    const dataPointRowLabel = props.dataPoint ? { "data-point": `${ props.dataPoint }_Row_Label` } : {};
    const dataPointRowIcon = props.dataPoint ? { "data-point": `${ props.dataPoint }_Row_Icon` } : {};
    const dataPointCheckbox = props.dataPoint ? { "dataPoint": props.dataPoint } : {};

    return (
        <CustomTableToggle>
            <TableItemContainer>
                <TableItemView className="entitlement-col" >
                    <div className="flex-container flex-horizontal align-center">
                        <span className="header-text" { ...dataPointRowLabel }>{header}</span>
                        {icon && <SVGAsset id={icon} className="right-double-chevron-icon" { ...dataPointRowIcon } />}
                    </div>
                </TableItemView>
                <TableItemTextView className="limit-col" />
                <TableItemView className="checkbox-col" >
                    <DisabledPrompt>
                        <UICheckbox label="" value="" { ...dataPointCheckbox } />
                    </DisabledPrompt>
                </TableItemView>
            </TableItemContainer>
        </CustomTableToggle>
    )
}

/**
 * @function EntitlementsTableItemContent
 * @param {STRING} item - 
 * @return {React.Component}
 * @exported true
 * @description This is the entitlement table item content.
 */
export function EntitlementsTableItemContent(props) {
    const item = props.item ?? "[item]";

    return (
        <CustomTableContent>
            <TableItemContainer>
                <TableItemTextView className="entitlement-item-col" text={item} />
                <TableItemTextView className="limit-col" />
                <TableItemView className="checkbox-col" >
                <DisabledPrompt>
                    <UICheckbox label="" value="" />
                </DisabledPrompt>
                </TableItemView>
            </TableItemContainer>
        </CustomTableContent>
    )
}
